import TipoUsuarioEnum from "~/domain/prova/TipoUsuarioEnum";

const routeMap = [
  {
    name: "Dashboard",
    icon: "fa-dashboard",
    path: "/prova/inicio",
    perfis: [TipoUsuarioEnum.ALUNO]
  },
  {
    name: "Administração",
    icon: "fa-user-shield",
    perfis: [TipoUsuarioEnum.ADMINISTRADOR],
    path: "/prova/administracao",
    routes: [
      {
        name: "Grupo de Conteúdo",
        path: "/prova/administracao/grupo-conteudo",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR]
      },
      {
        name: "Tipo de Prova",
        path: "/prova/administracao/tipo-prova",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR]
      },
      {
        name: "Tipo de Questão",
        path: "/prova/administracao/tipo-questao",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR]
      },
      {
        name: "Tipo de Usuário",
        path: "/prova/administracao/tipo-usuario",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR]
      }
    ]
  },
  {
    name: "Classificação",
    icon: "fa-list",
    perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR],
    path: "/prova/classificacao",
    routes: [
      {
        name: "Categoria",
        path: "/prova/classificacao/categoria",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Nível",
        path: "/prova/classificacao/nivel",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Tema",
        path: "/prova/classificacao/tema",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      }
    ]
  },
  {
    name: "Conteúdo",
    icon: "fa-book",
    perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR],
    path: "/prova/conteudo",
    routes: [
      {
        name: "Prova",
        path: "/prova/conteudo/prova",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Questão",
        path: "/prova/conteudo/questao",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Redação",
        path: "/prova/conteudo/redacao",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      }
    ]
  },
  {
    name: "Configurações",
    icon: "fa-wrench",
    perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR],
    path: "/prova/configuracoes",
    routes: [
      {
        name: "Critério",
        path: "/prova/configuracoes/criterio",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Grupo de Conceito",
        path: "/prova/configuracoes/grupo-conceito",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Modelo de Questão",
        path: "/prova/configuracoes/modelo-questao",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Usuário",
        path: "/prova/configuracoes/usuario",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      }
    ]
  },
  {
    name: "Gerenciamento",
    icon: "fa-paste",
    perfis: [
      TipoUsuarioEnum.ELABORADOR,
      TipoUsuarioEnum.AVALIADOR,
      TipoUsuarioEnum.ADMINISTRADOR
    ],
    path: "/prova/gerenciamento",
    routes: [
      {
        name: "Aplicação de Prova",
        path: "/prova/gerenciamento/aplicacao-prova",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR]
      },
      {
        name: "Impressão de Aplicação de Prova",
        path: "/prova/gerenciamento/aplicacaoProva/printProva",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR],
        hidden: true
      },
      {
        name: "Impressão de Gabarito",
        path: "/prova/gerenciamento/aplicacaoProva/printGabarito",
        perfis: [TipoUsuarioEnum.ADMINISTRADOR, TipoUsuarioEnum.ELABORADOR],
        hidden: true
      },
      {
        name: "Minhas Aplicações de Provas",
        path: "/prova/gerenciamento/minhas-provas",
        perfis: [
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ]
      },
      {
        name: "Minhas Questões Discursivas",
        path: "/prova/gerenciamento/minhas-questoes-discursivas",
        perfis: [
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ]
      },
      {
        name: "Minhas Redações",
        path: "/prova/gerenciamento/minhas-redacoes",
        perfis: [
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ]
      },
      {
        name: "Visualizar Notas dos Alunos",
        path: "/prova/gerenciamento/grupoAvaliacao/alunos",
        perfis: [
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ],
        hidden: true
      },
      {
        name: "Grupo de Avaliação",
        path: "/prova/gerenciamento/grupoAvaliacao",
        perfis: [TipoUsuarioEnum.ELABORADOR, TipoUsuarioEnum.ADMINISTRADOR]
      },
      {
        name: "Upload de Gabaritos",
        path: "/prova/gerenciamento/upload-gabarito",
        perfis: [TipoUsuarioEnum.ELABORADOR, TipoUsuarioEnum.ADMINISTRADOR]
      },
      {
        name: "Corrigir Questão Discursiva",
        path: "/prova/gerenciamento/corrigir-questao-discursiva",
        perfis: [
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ],
        hidden: true
      },
      {
        name: "Corrigir Redação",
        path: "/prova/gerenciamento/corrigir-redacao",
        perfis: [
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR,
          TipoUsuarioEnum.ADMINISTRADOR
        ],
        hidden: true
      },
      {
        name: "Realizar Prova",
        path: "/prova/gerenciamento/realizar-prova",
        perfis: [TipoUsuarioEnum.AVALIADOR],
        hidden: true
      }
    ]
  },
  {
    name: "Relatórios",
    icon: "fa-chart-bar",
    perfis: [
      TipoUsuarioEnum.ELABORADOR,
      TipoUsuarioEnum.AVALIADOR,
      TipoUsuarioEnum.ADMINISTRADOR
    ],
    path: "/prova/relatorios",
    routes: [
      {
        name: "Realizações de Provas",
        path: "/prova/relatorios/realizacao-prova",
        perfis: [
          TipoUsuarioEnum.ADMINISTRADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR
        ]
      },
      {
        name: "Monitoramento de Provas",
        path: "/prova/relatorios/monitoramento",
        perfis: [
          TipoUsuarioEnum.ADMINISTRADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR
        ]
      },
      {
        name: "Logs de Realização de Provas",
        path: "/prova/relatorios/logs",
        perfis: [
          TipoUsuarioEnum.ADMINISTRADOR,
          TipoUsuarioEnum.AVALIADOR,
          TipoUsuarioEnum.ELABORADOR
        ]
      }
    ]
  },
  {
    name: "Alunos",
    icon: "fa-graduation-cap",
    perfis: [TipoUsuarioEnum.ALUNO],
    path: "/prova/alunos",
    routes: [
      {
        name: "Minha Provas",
        path: "/prova/alunos/minhas-provas",
        perfis: [TipoUsuarioEnum.ALUNO]
      },
      {
        name: "Realizar Provas",
        path: "/prova/alunos/realizar-provas",
        perfis: [TipoUsuarioEnum.ALUNO]
      },
      {
        name: "Realizar Prova",
        path: "/prova/alunos/realizar-prova",
        perfis: [TipoUsuarioEnum.ALUNO],
        hidden: true
      },
      {
        name: "Visualizar Desempenho",
        path: "/prova/consulta/view/desempenho",
        perfis: [TipoUsuarioEnum.ALUNO],
        hidden: true
      },
      {
        name: "Visualizar Prova",
        path: "/prova/view/",
        perfis: [TipoUsuarioEnum.ALUNO],
        hidden: true
      }
    ]
  }
];

export default routeMap;



// WEBPACK FOOTER //
// ./src/routes/prova/routeMap.js